import moment from 'moment';
import { ONE_DAY, EMPTY_COUNT, FIELD_PRODUCT_ORDER, HALF_HYPHEN, MONTH_DAY_FORMAT, EMPTY_STRING, DAY_KANA, MONTH, PREDICTION_DATE_FORMAT } from '../../../../utils/constants';
import { FIELD_EMPTY } from '../../../../utils/messages';
import { isNullOrEmpty } from '../../../../utils/common';
import { PREDICTION } from './apiRoutes';
import ApiService from '../../../../utils/apiService';

function searchNearest(value, min, max, multiple) {
    let prediction = multiple * Math.floor(value / multiple) + (min % multiple);
    if(null !== max && max <= prediction){ return max;}
    if(null !== min && EMPTY_COUNT < value && value < min){ return min;}
    if(EMPTY_COUNT >= value){ return EMPTY_COUNT;}
    let displayValue = prediction < value ? prediction + multiple : prediction;
    
    return displayValue;
}

function calculateDailyEstimate(row, filterDate) {
    let numDays = moment(filterDate).date();
    let params = {row, filterDate, numDays, isDaily:true};

    return ApiService.post(PREDICTION +"/" + filterDate, params.row)
        .then((response) => {
            params.data = response.data.data;
            params.isValid = true;
            return getPredictions(params);
        });
}

function calculateMonthlyEstimate(row, filterDate) {
    let numDays = filterDate.daysInMonth();
    let params = {row, filterDate, numDays, isDaily:false};

    return ApiService.post(PREDICTION +"/" + filterDate, params.row)
        .then((response) => {
            params.data = response.data.data;
            params.isValid = true;
            return getPredictions(params);
        });
}

function getPredictions(params) {
    let dataValues = Object.keys(params.data).map(predict => params.data[predict].nohinDt.split("-").join(""));
    
    let checkDate = moment(params.filterDate).startOf(MONTH).format(PREDICTION_DATE_FORMAT);
    let resultDisplay = [];
    let decrement = EMPTY_COUNT;
    let iCount = 0;
    let resultIndex = 0;
    let dayFlags = [
        params.row.sunFlag,
        params.row.monFlag,
        params.row.tueFlag,
        params.row.wedFlag,
        params.row.thuFlag,
        params.row.friFlag,
        params.row.satFlag,
    ];


    while (iCount <= params.numDays - ONE_DAY) {
        if (EMPTY_COUNT <= dataValues.indexOf(checkDate)) {
            let predictedValue = params.data[resultIndex].predictionValue;
            /*let resultValue = predictedValue - decrement;
            let display = EMPTY_COUNT;

            if(dayFlags[moment(checkDate).day()]){
                if (null === params.row.maxOrder) {
                    if (resultValue <= params.row.minOrder) {
                        display = params.row.minOrder;
                    } else if (EMPTY_COUNT === (resultValue - params.row.minOrder) % params.row.multiple) {
                        display = resultValue;
                    } else {
                        display = searchNearest(resultValue, params.row.minOrder, params.row.maxOrder, params.row.multiple);
                    }   
                } else {
                    display = searchNearest(resultValue, params.row.minOrder, params.row.maxOrder, params.row.multiple); 
                }
            }

            resultDisplay.push(display);
            decrement = Number((display - resultValue).toFixed(2));*/
            
            resultDisplay.push(predictedValue);
            resultIndex++;
        } else {
            params.isValid ? resultDisplay.push(HALF_HYPHEN) : resultDisplay.push(EMPTY_STRING);
        }

        if (params.isDaily && iCount === (params.numDays - ONE_DAY)) {
            let result = {
                productCode: params.row.productCode,
                prediction: resultDisplay[iCount]
            }
            
            return result;
        }

        checkDate = (Number(checkDate) + ONE_DAY).toString();
        iCount++;
    }

    return resultDisplay;
}

function validate(orderList, isDaily) {

    let prompt = [];

    orderList.map((item, index) => {
        let qty = item[FIELD_PRODUCT_ORDER];
        let min = item.minOrder;
        let max = item.maxOrder;
        let multi = item.multiple;

        let lineRow = isDaily ? `行[${index + 1}] : ` : `日付[${moment(item.deliveryDate).format(MONTH_DAY_FORMAT)} (${DAY_KANA[moment(item.deliveryDate).day()]})] : `;

        if ((undefined === qty || isNullOrEmpty(qty)) && !isNullOrEmpty(item.dbOrdered)) {
            prompt.push(lineRow + `数量${FIELD_EMPTY}`);
        } else if (EMPTY_COUNT < qty) {
            let diff = qty - min;
            if (EMPTY_COUNT < min && qty < min) {
                prompt.push(lineRow + `数量[${qty}]が最小注文数[${min}]より小さいです。`)
            } else if (EMPTY_COUNT < max && qty > max) {
                prompt.push(lineRow + `数量[${qty}]が最大注文数[${max}]より大きいです。`)
            } else if (qty !== max){ 
                if (EMPTY_COUNT < diff && EMPTY_COUNT < diff % multi) {
                    prompt.push(lineRow + `数量[${qty}]が倍数[${multi}]ではありません。`)
                }
            }
        } else if (EMPTY_COUNT > qty) {
            prompt.push(lineRow + `数量[${qty}]は 0 以上を入力してください。`);
        }

        return item;
    })

    return prompt;
}

export {
    calculateDailyEstimate,
    calculateMonthlyEstimate,
    validate
};